window.monitoringRequestCsenceFormatter = function(value, row) {
    switch (value) {
        case "OK":
            return '<span class="badge badge-monitoring-request-csence-ok">OK</span>';
        case "FAILED":
            return '<span class="badge badge-monitoring-request-csence-failed">FAILED</span>';
        case "WARNING":
            return '<span class="badge badge-monitoring-request-csence-warning">WARNING</span>';
        case "IGNORED":
            return '<span class="badge badge-monitoring-request-csence-ignored">IGNORED</span>';
        case "UNKNOWN":
            return '<span class="badge badge-monitoring-request-csence-unknown">UNKNOWN</span>';
        case "INFO":
            return '<span class="badge badge-monitoring-request-csence-info">INFO</span>';
        default:
            return value;
    }
};
